import { GetListResponse } from 'src/sdk-servicing';
import { createAction, props } from '@ngrx/store';
import { asyncProps, FromApiActionPayload, WithRequestId, AsyncRequest } from '@lib/store';
import { BusinessTripGetListModel } from './business-trip-get-list.state';

/** StateDetailsActions */
const ACTION_SET = '[BusinessTripGetList] set';
const ACTION_UPDATE = '[BusinessTripGetList] update';
const ACTION_RESET = '[BusinessTripGetList] reset';
const ACTION_FAIL = '[BusinessTripGetList] fail';
const ACTION_CANCEL_REQUEST = '[BusinessTripGetList] cancel request';

/** Async Actions */
const ACTION_SET_FROM_API = '[BusinessTripGetList] set from api';
const ACTION_UPDATE_FROM_API = '[BusinessTripGetList] update from api';

/**
 * Clear the current store object and replace it with the new one,
 * update isFailure to false, and update isPending with the boolean given as parameter if defined
 */
export const setBusinessTripGetList = createAction(ACTION_SET, props<WithRequestId<BusinessTripGetListModel>>());

/**
 * Change a part or the whole object in the store and update isFailure to false. The pendingUpdate boolean,
 * if set to true or false, will update the isPending property from the StateDetails
 */
export const updateBusinessTripGetList = createAction(
  ACTION_UPDATE,
  props<WithRequestId<Partial<BusinessTripGetListModel>>>()
);

/**
 * Clear the whole state, return to the initial one
 */
export const resetBusinessTripGetList = createAction(ACTION_RESET);

/** Action to cancel a Request ID registered in the store. Can happen from effect based on a switchMap for instance */
export const cancelBusinessTripGetListRequest = createAction(ACTION_CANCEL_REQUEST, props<AsyncRequest>());

/**
 * Update isPending from the StateDetails to false, and isFailure to true
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const failBusinessTripGetList = createAction(ACTION_FAIL, props<WithRequestId<{ error: any }>>());

/**
 * Update isPending to true, triggers setFromApi Effect
 */
export const setBusinessTripGetListFromApi = createAction(
  ACTION_SET_FROM_API,
  asyncProps<FromApiActionPayload<GetListResponse>>()
);

/**
 * Update isPending to true, triggers updateFromApi Effect
 */
export const updateBusinessTripGetListFromApi = createAction(
  ACTION_UPDATE_FROM_API,
  asyncProps<FromApiActionPayload<GetListResponse>>()
);
